import ListView from '@/components/common/ListView/ListView'
import ListViewColumn from '@/components/common/ListViewColumn/ListViewColumn'
import ListViewHeader, { ListViewHeaderColumn } from '@/components/common/ListViewHeader/ListViewHeader'
import ListViewRow from '@/components/common/ListViewRow/ListViewRow'
import { useTranslation } from 'next-i18next'
import React from 'react'

type Props = {}

const TyreLoadIndex = (props: Props) => {
  const { t } = useTranslation()

  const columnSettings: ListViewHeaderColumn[] = [
    {
      name: 'loadIndex',
      label: t('tyres:loadIndex'),
      className: 'col-xs-2'
    },
    {
      name: 'loadInKilograms',
      label: t('tyres:loadIndexInKilograms'),
      className: 'col-xs'
    }
  ]

  const data = [
    { loadIndex: '50', loadInKilograms: '190' },
    { loadIndex: '51', loadInKilograms: '195' },
    { loadIndex: '52', loadInKilograms: '200' },
    { loadIndex: '53', loadInKilograms: '206' },
    { loadIndex: '54', loadInKilograms: '212' },
    { loadIndex: '55', loadInKilograms: '218' },
    { loadIndex: '56', loadInKilograms: '224' },
    { loadIndex: '57', loadInKilograms: '230' },
    { loadIndex: '58', loadInKilograms: '236' },
    { loadIndex: '59', loadInKilograms: '243' },
    { loadIndex: '60', loadInKilograms: '250' },
    { loadIndex: '61', loadInKilograms: '257' },
    { loadIndex: '62', loadInKilograms: '265' },
    { loadIndex: '63', loadInKilograms: '272' },
    { loadIndex: '64', loadInKilograms: '280' },
    { loadIndex: '65', loadInKilograms: '290' },
    { loadIndex: '66', loadInKilograms: '300' },
    { loadIndex: '67', loadInKilograms: '307' },
    { loadIndex: '68', loadInKilograms: '315' },
    { loadIndex: '69', loadInKilograms: '325' },
    { loadIndex: '70', loadInKilograms: '335' },
    { loadIndex: '71', loadInKilograms: '345' },
    { loadIndex: '72', loadInKilograms: '355' },
    { loadIndex: '73', loadInKilograms: '365' },
    { loadIndex: '74', loadInKilograms: '375' },
    { loadIndex: '75', loadInKilograms: '387' },
    { loadIndex: '76', loadInKilograms: '400' },
    { loadIndex: '77', loadInKilograms: '412' },
    { loadIndex: '78', loadInKilograms: '425' },
    { loadIndex: '79', loadInKilograms: '437' },
    { loadIndex: '80', loadInKilograms: '450' },
    { loadIndex: '81', loadInKilograms: '462' },
    { loadIndex: '82', loadInKilograms: '475' },
    { loadIndex: '83', loadInKilograms: '487' },
    { loadIndex: '84', loadInKilograms: '500' },
    { loadIndex: '85', loadInKilograms: '515' },
    { loadIndex: '86', loadInKilograms: '530' },
    { loadIndex: '87', loadInKilograms: '545' },
    { loadIndex: '88', loadInKilograms: '560' },
    { loadIndex: '89', loadInKilograms: '580' },
    { loadIndex: '90', loadInKilograms: '600' },
    { loadIndex: '91', loadInKilograms: '615' },
    { loadIndex: '92', loadInKilograms: '630' },
    { loadIndex: '93', loadInKilograms: '650' },
    { loadIndex: '94', loadInKilograms: '670' },
    { loadIndex: '95', loadInKilograms: '690' },
    { loadIndex: '96', loadInKilograms: '710' },
    { loadIndex: '97', loadInKilograms: '730' },
    { loadIndex: '98', loadInKilograms: '750' },
    { loadIndex: '99', loadInKilograms: '775' },
    { loadIndex: '100', loadInKilograms: '800' },
    { loadIndex: '101', loadInKilograms: '825' },
    { loadIndex: '102', loadInKilograms: '850' },
    { loadIndex: '103', loadInKilograms: '875' },
    { loadIndex: '104', loadInKilograms: '900' },
    { loadIndex: '105', loadInKilograms: '925' },
    { loadIndex: '106', loadInKilograms: '950' },
    { loadIndex: '107', loadInKilograms: '975' },
    { loadIndex: '108', loadInKilograms: '1000' },
    { loadIndex: '109', loadInKilograms: '1030' },
    { loadIndex: '110', loadInKilograms: '1060' },
    { loadIndex: '111', loadInKilograms: '1090' },
    { loadIndex: '112', loadInKilograms: '1120' },
    { loadIndex: '113', loadInKilograms: '1150' },
    { loadIndex: '114', loadInKilograms: '1180' },
    { loadIndex: '115', loadInKilograms: '1215' },
    { loadIndex: '116', loadInKilograms: '1250' },
    { loadIndex: '117', loadInKilograms: '1285' },
    { loadIndex: '118', loadInKilograms: '1320' },
    { loadIndex: '119', loadInKilograms: '1360' },
    { loadIndex: '120', loadInKilograms: '1400' },
    { loadIndex: '121', loadInKilograms: '1450' },
    { loadIndex: '122', loadInKilograms: '1500' },
    { loadIndex: '123', loadInKilograms: '1550' },
    { loadIndex: '124', loadInKilograms: '1600' },
    { loadIndex: '125', loadInKilograms: '1650' },
    { loadIndex: '126', loadInKilograms: '1700' },
    { loadIndex: '127', loadInKilograms: '1750' },
    { loadIndex: '128', loadInKilograms: '1800' },
    { loadIndex: '129', loadInKilograms: '1850' },
    { loadIndex: '130', loadInKilograms: '1900' },
    { loadIndex: '131', loadInKilograms: '1950' },
    { loadIndex: '132', loadInKilograms: '200' },
    { loadIndex: '133', loadInKilograms: '2060' },
    { loadIndex: '134', loadInKilograms: '2120' },
    { loadIndex: '135', loadInKilograms: '2180' },
    { loadIndex: '136', loadInKilograms: '2240' },
    { loadIndex: '137', loadInKilograms: '2300' },
    { loadIndex: '138', loadInKilograms: '2360' },
    { loadIndex: '139', loadInKilograms: '2430' },
    { loadIndex: '140', loadInKilograms: '2500' },
    { loadIndex: '141', loadInKilograms: '2575' },
    { loadIndex: '142', loadInKilograms: '2650' },
    { loadIndex: '143', loadInKilograms: '2725' },
    { loadIndex: '144', loadInKilograms: '2800' },
    { loadIndex: '145', loadInKilograms: '2900' },
    { loadIndex: '146', loadInKilograms: '3000' },
    { loadIndex: '147', loadInKilograms: '3075' },
    { loadIndex: '148', loadInKilograms: '3150' },
    { loadIndex: '149', loadInKilograms: '3250' },
    { loadIndex: '150', loadInKilograms: '3350' },
    { loadIndex: '151', loadInKilograms: '3450' },
    { loadIndex: '152', loadInKilograms: '3550' },
    { loadIndex: '153', loadInKilograms: '3650' },
    { loadIndex: '154', loadInKilograms: '3750' },
    { loadIndex: '155', loadInKilograms: '3875' },
    { loadIndex: '156', loadInKilograms: '4000' },
    { loadIndex: '157', loadInKilograms: '4125' },
    { loadIndex: '158', loadInKilograms: '4250' },
    { loadIndex: '159', loadInKilograms: '4375' },
    { loadIndex: '160', loadInKilograms: '4500' },
    { loadIndex: '161', loadInKilograms: '4625' },
    { loadIndex: '162', loadInKilograms: '4750' },
    { loadIndex: '163', loadInKilograms: '4875' },
    { loadIndex: '164', loadInKilograms: '5000' },
    { loadIndex: '165', loadInKilograms: '5150' },
    { loadIndex: '166', loadInKilograms: '5300' },
    { loadIndex: '167', loadInKilograms: '5450' },
    { loadIndex: '168', loadInKilograms: '5600' },
    { loadIndex: '169', loadInKilograms: '5800' }
  ]

  return (
    <div>
      <ListView
        columns={columnSettings}
      >
        {
          (columns) => {
            return (
              <>
                <ListViewHeader columns={columnSettings} />
                {data.map((item, index) => (
                  <ListViewRow key={index}>
                    <ListViewColumn column={columns.loadIndex} >
                      {item.loadIndex}
                    </ListViewColumn>
                    <ListViewColumn column={columns.loadInKilograms}>
                      {item.loadInKilograms}
                    </ListViewColumn>
                  </ListViewRow>
                ))}

              </>
            )
          }
        }
      </ListView>
    </div>
  )
}

export default TyreLoadIndex